import { Injectable } from '@angular/core';
import { RestApiService } from '../rest-api.service';
import { Observable } from 'rxjs';
import { IMessageGroupMGInputModel, IMessageGroupListInputModel, ISignatureInputModel, ISignatureListInputModel, ISignatureOutputModel, IMessageInputModel, IMsgSLNoInputModel, IMsgListInputModel, IMsgHistoryInputModel, IMsgReceiverStatus, IMsgAttachmentsModel, ICommunicationInputModel, ICommunicationProtocol } from 'src/app/ViewModel/CommunicationModel';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {
  private getMsgSerialNo = 'Communication/GetMsgSerialNo';
  private insertSignature = 'Communication/InsertMessageSignature';
  private getSignatureList = 'Communication/GetMessageSignatureList';
  private insertMessage = 'Communication/InsertMessage';
  private getMessageGroupList = 'Communication/GetMessageGroupList';
  private insertUpdateMessageGroup = 'Communication/InsertUpdateMessageGroup';
  private getMessageList = 'Communication/GetMessageList';
  private insertSearch = 'Communication/InsertMessageSearch';
  private removeSearch = 'Communication/RemoveMessageSearch';
  private searchList = 'Communication/GetMessageSearchList';
  private getMessageReceiverList = 'Communication/GetMessageReceivers';
  private getMessageAttachmentList = 'Communication/GetMessageAttachments';
  private getMessageDocumentList = 'Communication/GetMessageDocuments';
  private getMessageDetailsList = 'Communication/GetMessageDetails';
  private getmessageElementsById='Communication/GetMessageElementsById';
  private getMessageStatusLogUrl='Communication/GetMessageStatusLog';
  private getMessageHistoryDetailsUrl='Communication/GetMessageHistoryDetails';
  private setMessageStatusUrl = 'Communication/UpdateMessageReceiverStatus';
  private updateDocumentsMsgId = 'Communication/UpdateDocumentsMsgId';
  private deleteMessage = 'Communication/DeleteMessage';  
  private GetCommunicationProtocolUrl = 'Communication/GetProjectCommunicationProtocol';
  private PostCommunicationProtocolUrl = 'Communication/PostProjectCommunicationProtocol';
  constructor(private restAPIService: RestApiService) { }
  /**
 * Fetching MemberID  based on Signatures
 * @param MemberId
 */
  public GetSignatureList(signatureListInputModel: ISignatureListInputModel): Observable<any> {
    return this.restAPIService.new_POST(this.getSignatureList, signatureListInputModel);
  }

  public InsertSignature(signatureInputModel: ISignatureInputModel): Observable<any> {
    return this.restAPIService.new_POST(this.insertSignature, signatureInputModel);
  }
  /**
   * Fetching MemberID  based on Message Group
   * @param MemberId
   */
  public GetMessageGroup(messageGroupListInputModel: IMessageGroupListInputModel): Observable<any> {
    return this.restAPIService.new_POST(this.getMessageGroupList, messageGroupListInputModel);
  }

  public InsertUpdateMessageGroup(messageGroupInputModel: IMessageGroupMGInputModel): Observable<any> {
    return this.restAPIService.new_POST(this.insertUpdateMessageGroup, messageGroupInputModel);
  }

  public InsertMessage(messageInputModel: IMessageInputModel): Observable<any> {
    return this.restAPIService.new_POST(this.insertMessage, messageInputModel);
  }

  /**
  * Generate Serial No based on Message Element Details
  * @param MsgSLNo
  */
  public GetMsgSerialNo(msgInputModel: IMsgSLNoInputModel): Observable<any> {
    return this.restAPIService.new_POST(this.getMsgSerialNo, msgInputModel);
  }

  public GetMessageList(msgInputModel: IMsgListInputModel): Observable<any> {
    return this.restAPIService.new_POST(this.getMessageList, msgInputModel);
  }


  public insertMessageSearch(msgInputModel: any): Observable<any> {
    return this.restAPIService.new_POST(this.insertSearch, msgInputModel);
  }

  public removeMessageSearch(projectId?: number, memberId?: number, searchId?: number): Observable<any> {
    let reqData = {
      'projectId': projectId,
      'memberId': memberId,
      'searchId': searchId
    };
    return this.restAPIService.new_POST(this.removeSearch, reqData);
  }

  public getMessageSearchList(projectId?: number, memberId?: number): Observable<any> {
    let reqData = {
      'projectId': projectId,
      'memberId': memberId
    };
    return this.restAPIService.new_POST(this.searchList, reqData);
  }
  public GetMessageReceiverList(messageId: number): Observable<any> {
    let messageIdModel = { messageId: messageId };
    return this.restAPIService.new_POST(this.getMessageReceiverList, messageIdModel);
  }
  public getMessageAttachmentsList(messageId: number): Observable<any> {
    let messageIdModel = { messageId: messageId };
    return this.restAPIService.new_POST(this.getMessageAttachmentList, messageIdModel);
  }
  public getMessageDocumentsList(messageId: number): Observable<any> {
    let messageIdModel = { messageId: messageId };
    return this.restAPIService.new_POST(this.getMessageDocumentList, messageIdModel);
  }
  public getMessageDetails(messageId: number): Observable<any> {
    let messageIdModel = { messageId: messageId };
    return this.restAPIService.new_POST(this.getMessageDetailsList, messageIdModel);
  }
  public getMessageElementsById(messageId: number): Observable<any> {
    let messageIdModel = { messageId: messageId };
    return this.restAPIService.new_POST(this.getmessageElementsById, messageIdModel);
  }
  public getMessageStatusLog(messageId: number): Observable<any> {
    let messageIdModel = { messageId: messageId };
    return this.restAPIService.new_POST(this.getMessageStatusLogUrl, messageIdModel);
  }

  public getMessageHistoryDetails(msgHistoryInputModel: IMsgHistoryInputModel): Observable<any> {
    return this.restAPIService.new_POST(this.getMessageHistoryDetailsUrl, msgHistoryInputModel);
  }

  public setMessageStatus(msgInputModel: IMsgReceiverStatus): Observable<any> {
    return this.restAPIService.new_POST(this.setMessageStatusUrl, msgInputModel);
  }

  public updateCommunicationDocsMsgId(commDocs:IMsgAttachmentsModel) : Observable<any>{
    return this.restAPIService.new_POST(this.updateDocumentsMsgId, commDocs);
  }

  public DeleteMessage(data: any): Observable<any> {
    return this.restAPIService.new_POST(this.deleteMessage, data);
  }
  public GetCommunicationProtocol(commInp:ICommunicationInputModel) : Observable<any>{
    return this.restAPIService.new_POST(this.GetCommunicationProtocolUrl, commInp);
  }
  public PostProjectCommunicationProtocol(commInp:ICommunicationProtocol) : Observable<any>{
    return this.restAPIService.new_POST(this.PostCommunicationProtocolUrl, commInp);
  }

}
